/* eslint-disable camelcase */
import Video from './__constants/video';
import menuSlider from './__page/block-slider';
import {newsSliderTop, menuNavSlider, sliderBlockMain, sliderBlockNav} from './__page/block-slider';
import footerAccordion from './__utils/accordion';
import {sectionAccordion} from './__utils/accordion';
import Menu from './__page/hamburger-menu';
import popup, {popupProduct} from './__utils/popup';
import equal_content_1 from './__utils/equalContentHeight';
import {equal_content_2, equal_content_3} from './__utils/equalContentHeight';
import ScrollToNextSection from './__utils/scrollToNextSection';
import OpenMenuItem from './__page/open-menu-item';
import heroHeight from './__page/hero-height';
import Tabs from './__utils/tabs';
import SetCircleText from './__utils/set-circle-text';
import NavigateMenuItems from './__page/navigate-menu-items';
import VideoPopup from './__page/video-popup';
import FlipItem from './__utils/flip-item';
import FormNavigation from './__page/form-navigation';
import Quiz from './__page/quiz';
import classOnRadio from './__utils/label-adding-class';
import {classOnCheckbox} from './__utils/label-adding-class';
import CheckBrowser from './__utils/check-browser';
import StyleSelect from './__utils/style-select';
import device from './__constants/device';
import smoothScroll from './__utils/smoothScroll';
//import productPopupScripts from './__woocommerce/product-popup';
import StoreSlider from './__woocommerce/store-slider';
import StorePopup from './__woocommerce/store-popup';
import AjaxAddToCart from './__woocommerce/ajax-add-to-cart';
import StickyCart from './__woocommerce/sticky-cart';
import CheckoutSlider from './__woocommerce/checkout-slider';

import FormValidation from './__page/form-custom-validation';

import navigationImages from './__page/navigation-images';
import heroSlider from './__page/hero-slider';
import menuItemsSlider from './__page/slider-menu-items';
import controlsSlider from './__page/full-page-slider/controls-slider';
import animateBorders from './__page/animate-borders';
import buttonFullpageContent from './__page/menu-food/button-fullpage-content';
import stepForm from './__page/step-form-new/step-form';
import thankYouPopup from './__page/step-form-new/thank-you-popup';

jQuery(document).ready(() => {
    footerAccordion.init();
    sectionAccordion.init();
    Menu.init();
    popup.init();
    popupProduct.init();
    Tabs.init();
    SetCircleText.init();
    NavigateMenuItems.init();
    VideoPopup.init();
    FlipItem.init();
    FormNavigation.init();
    classOnRadio.init();
    Quiz.init();
    classOnCheckbox.init();
    CheckBrowser();
    heroHeight();
    StyleSelect();
    device.isPhone();
    device.isTablet();
    smoothScroll();
    FormValidation.init();
    //productPopupScripts();
    StoreSlider.init();
    StorePopup.init();
    AjaxAddToCart.init();
    StickyCart.init();
    CheckoutSlider.init();
    navigationImages.setPrimaryActive();
    navigationImages.changeOnHover();
    heroSlider.init();
    controlsSlider.init();
    buttonFullpageContent.init();
    stepForm.init();
    thankYouPopup.init();
});

window.addEventListener('load', () => {
    Video();
    //menuSlider.init();
    menuItemsSlider.init();
    newsSliderTop.init();
   // menuNavSlider.init();
    sliderBlockMain.init();
    sliderBlockNav.init();
    equal_content_1.init();
    equal_content_2.init();
    equal_content_3.init();
    ScrollToNextSection.init();
    OpenMenuItem.init();
    FormNavigation.setFormWrapHeight();
    animateBorders.init();
});

window.addEventListener('resize', () => {
    equal_content_1.init();
    equal_content_2.init();
    equal_content_3.init();
    FormNavigation.setFormWrapHeight();
    footerAccordion.setHeight();
    sectionAccordion.setHeight();
    OpenMenuItem.equalizeItemHeights();
    heroHeight();
    menuItemsSlider.init();

});

window.addEventListener('scroll', ()=>{
    animateBorders.init();
});

jQuery(document.body).on('updated_cart_totals', () => {
    StyleSelect();
});
